import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { ArrowLeft, Search, Trash2, Eye, BookMarked } from "lucide-react";

export default function SavedKundlis() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/kundli/saved", { params: q ? { q } : {} }).then(r => setItems(r.data)).catch(() => toast.error("Could not load saved Kundlis"));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const remove = async (id) => {
    if (!window.confirm("Delete this saved Kundli?")) return;
    await api.delete(`/kundli-history/${id}`);
    setItems(items.filter(i => i.id !== id));
    toast.success("Deleted");
  };

  return (
    <div className="space-y-6" data-testid="saved-kundlis-page">
      <div className="flex items-center gap-3 flex-wrap">
        <Button variant="ghost" onClick={() => nav("/kundli")} data-testid="saved-kundlis-back"><ArrowLeft className="w-4 h-4 mr-1" /> Back</Button>
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-amber-600 dark:text-amber-400">Records</div>
          <h1 className="font-display text-3xl md:text-4xl font-light tracking-tight mt-1 flex items-center gap-2">
            <BookMarked className="w-6 h-6 text-amber-500" /> Saved Kundlis
          </h1>
        </div>
      </div>
      <div className="relative max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Search by name, serial no or place" className="pl-9 h-11 rounded-xl" data-testid="saved-kundlis-search" />
      </div>
      {items.length === 0 ? (
        <Card className="p-12 rounded-2xl text-center border-dashed" data-testid="saved-kundlis-empty">
          <p className="text-slate-500">No saved Kundlis yet. Generate a Kundli and click Save.</p>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map(rec => (
            <Card key={rec.id} className="p-5 rounded-2xl card-lift border-slate-200 dark:border-slate-800" data-testid={`saved-kundli-${rec.id}`}>
              <div className="flex items-start justify-between gap-2">
                <div>
                  <Badge variant="secondary" className="font-mono text-[10px]" data-testid={`saved-kundli-serial-${rec.id}`}>{rec.serial_no || "—"}</Badge>
                  <div className="font-display text-lg mt-2">{rec.client_name || "Unnamed"}</div>
                  <div className="text-xs text-slate-500">{rec.dob} {rec.tob} · {rec.place}</div>
                  <div className="text-xs text-slate-500 mt-0.5">Lagna {rec.lagna} · Moon {rec.moon_sign}</div>
                </div>
                <div className="text-[10px] font-mono text-slate-400">{(rec.created_at || "").slice(0, 10)}</div>
              </div>
              <div className="mt-3 pt-3 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-1">
                <Button size="sm" variant="ghost" onClick={() => nav(`/kundli?id=${rec.id}`)} data-testid={`saved-kundli-open-${rec.id}`}><Eye className="w-3 h-3 mr-1" /> Open</Button>
                <Button size="sm" variant="ghost" className="text-red-600" onClick={() => remove(rec.id)} data-testid={`saved-kundli-delete-${rec.id}`}><Trash2 className="w-3 h-3" /></Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
